var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49999 3.75C4.39874 3.75 1.87499 6.27313 1.87499 9.375C1.87499 12.4769 4.39874 15 7.49999 15C10.6012 15 13.125 12.4769 13.125 9.375C13.125 6.27313 10.6012 3.75 7.49999 3.75ZM8.12499 12.5H6.87499V8.36625L6.38749 8.87187L5.48811 8.00375L7.18061 6.25H8.12561V12.5H8.12499ZM8.12374 2.52875L9.37499 0H14.2919L12.1544 4.32C11.0725 3.32313 9.67124 2.66875 8.12374 2.52875ZM2.79624 4.36562L0.642487 0H5.62499L6.87249 2.52875C5.30249 2.67125 3.88374 3.34375 2.79624 4.36562Z",
    fill: "#F2CC75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstMedal);
export default __webpack_public_path__ + "static/media/FirstMedal.a0a4352a5c782f7d7ab32975e95d499a.svg";
export { ForwardRef as ReactComponent };